import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import ReviewModal from './review-modal';

interface ReviewModalPortalProps {
  isOpen: boolean;
  onClose: () => void;
  professionalId: string;
  professionalName?: string;
}

/**
 * Portail pour le modal d'avis qui le rend au niveau racine du DOM
 */
const ReviewModalPortal: React.FC<ReviewModalPortalProps> = (props) => {
  const [modalRoot, setModalRoot] = useState<HTMLElement | null>(null);
  
  useEffect(() => {
    // Créer ou récupérer l'élément racine pour le portail
    let element = document.getElementById('modal-root');
    if (!element) {
      element = document.createElement('div');
      element.id = 'modal-root';
      document.body.appendChild(element);
    }
    setModalRoot(element);
    
    // Nettoyage lors du démontage
    return () => {
      // Ne pas supprimer l'élément racine car il pourrait être utilisé par d'autres modaux
    };
  }, []);
  
  // Ne rien rendre tant que l'élément racine n'est pas disponible
  if (!modalRoot) return null;
  
  // Utiliser createPortal pour rendre le modal en dehors de la hiérarchie DOM normale
  return createPortal(
    <ReviewModal {...props} />,
    modalRoot
  );
};

export default ReviewModalPortal;
